<template>
  <el-card class="h-full relative">
    <div class="h-full flex flex-col">
      <div class="flex mb-10px flex-wrap">
        <el-input
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请输入关键字"
          v-model="searchData.keywords"
          clearable
        ></el-input>
        <el-select
          v-model="searchData.troubleshootType"
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请选择排查类型"
          clearable
        >
          <el-option
            v-for="item in checkTypeList"
            :key="item.value"
            :label="item.displayName"
            :value="Number(item.code)"
          ></el-option>
        </el-select>
        <department-select
          ref="departmentSelect"
          class="mr-10px !w-50 mb-10px"
          v-model="searchData.organizationalUnitId"
        ></department-select>
        <el-date-picker
          class="mr-10px mb-10px"
          v-model="datePickerValue"
          format="yyyy-MM-dd"
          size="small"
          type="daterange"
          :clearable="true"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <el-button class="mb-10px" size="small" type="primary" @click="searchList">搜索</el-button>
        <el-button class="mb-10px" size="small" @click="resetSearch">重置</el-button>
        <!-- :disabled="!$hasAccess('create')" -->
        <el-button class="mb-10px" type="primary" size="small" @click="handleEvent(null, 'create')">
          新增
        </el-button>
        <!-- <el-button size="small" @click="handleEvent(null, 'export')">
        导出
      </el-button> -->
      </div>
      <div class="flex-auto h-0px">
        <el-table
          ref="table"
          :data="tableData"
          border
          class="w-full"
          :height="tableHeight"
          stripe
          v-loading="loading"
        >
          <!-- <el-table-column type="selection" width="50"></el-table-column> -->
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column
            label="计划名称"
            prop="planName"
            min-width="200"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="任务总数"
            prop="totalTaskCount"
            min-width="80"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="已完成数"
            prop="completedCount"
            min-width="80"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="完成率"
            prop="completionRate"
            min-width="80"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="排查类型" prop="planType" min-width="200" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ checkTypeMap(scope.row.planType) }}
            </template>
          </el-table-column>
          <el-table-column
            label="组织单位"
            prop="organizationalUnitStr"
            min-width="200"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="组织负责人"
            prop="headOrganizationStr"
            min-width="200"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="所属风险点"
            prop="riskPoints"
            min-width="200"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="排查人"
            prop="deadlinePersonStrs"
            min-width="200"
            show-overflow-tooltip
          ></el-table-column>
          <!-- <el-table-column
        label="被排查单位"
        prop="title"
        min-width="200"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="整体排查目标"
        prop="title"
        min-width="200"
        show-overflow-tooltip
      ></el-table-column> -->
          <el-table-column
            label="排查开始时间"
            prop="investigationTimeStart"
            min-width="200"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{
                scope.row.investigationTimeStart &&
                  dayjs(scope.row.investigationTimeStart).format('YYYY-MM-DD HH:mm:ss')
              }}
            </template>
          </el-table-column>
          <el-table-column
            label="排查截止时间"
            prop="investigationTimeEnd"
            min-width="200"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{
                scope.row.investigationTimeEnd &&
                  dayjs(scope.row.investigationTimeEnd).format('YYYY-MM-DD HH:mm:ss')
              }}
            </template>
          </el-table-column>
          <el-table-column label="计划状态" prop="planStatus" min-width="200" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.planStatus ? '已发布' : '待发布' }}
            </template>
          </el-table-column>
          <el-table-column
            label="计划发布时间"
            prop="planPublishTime"
            min-width="200"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{
                scope.row.planPublishTime &&
                  dayjs(scope.row.planPublishTime).format('YYYY-MM-DD HH:mm:ss')
              }}
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="350">
            <template slot-scope="scope">
              <el-button
                :disabled="!($hasAccess('publish') && !scope.row.planStatus)"
                @click.stop="handleEvent(scope.row, 'publish')"
                size="mini"
                >发布</el-button
              >
              <el-button
                size="mini"
                @click.native="handleEvent(scope.row, 'read')"
                :disabled="!$hasAccess('read')"
                >查看</el-button
              >
              <el-button
                size="mini"
                :disabled="!($hasAccess('publish') && !scope.row.planStatus)"
                @click="handleEvent(scope.row, 'update')"
                >编辑</el-button
              >
              <el-button
                size="mini"
                @click.native="handleEvent(scope.row, 'completionStatus')"
                :disabled="!($hasAccess('publish') && !!scope.row.planStatus)"
                >完成情况</el-button
              >
              <el-button
                :disabled="!$hasAccess('delete')"
                size="mini"
                @click.stop="handleEvent(scope.row, 'delete')"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @size-change="searchList"
          @current-change="findList"
          :current-page.sync="pageNo"
          :page-size.sync="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[15, 30, 45, 60, 75, 90]"
          :total="total"
          class="float-right mt-20px ml-10px"
        ></el-pagination>
      </div>
    </div>
    <CheckPlanForm
      v-if="formDialog"
      :formProps="formProps"
      :formData="formData"
      @refreshList="refreshList"
      @cancel="formDialog = false"
    />
  </el-card>
</template>

<script>
import { HiddenDangerInvestigationPlanApi } from '@wiz-api/double-prevention-management'
import dayjs from 'dayjs'
import utils from '@/components/safety/enumField/utils'
import DepartmentSelect from '@/components/safety/DepartmentSelect/DepartmentSelect'
import CheckPlanForm from '../components/CheckPlan/CheckPlanForm'

const hiddenDangerInvestigationPlanApi = new HiddenDangerInvestigationPlanApi()

export default {
  name: 'check-plan',
  components: {
    DepartmentSelect,
    CheckPlanForm,
  },
  data() {
    return {
      formData: {},
      formDialog: false,
      datePickerValue: [],
      id: '',
      formProps: {
        title: '新增隐患排查计划',
        visible: false,
        // create 新增 update 编辑 read 详情
        editType: 'create',
      },
      checkTypeList: [],
      // 作业活动清单
      tableData: [],
      loading: false,
      searchData: {
        type: '',
        readStatus: '',
        title: '',
      },
      total: 0,
      pageNo: 1,
      pageSize: 15,
      selectionData: [],
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 54px)'
    },
    checkTypeMap() {
      return (val) => {
        return (
          this.checkTypeList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
  },
  created() {
    utils.getDataCategory(
      ['DoublePreventionManagement.DataCategory.CheckType'],
      ['checkTypeList'],
      this
    )
    this.searchList()
  },
  watch: {
    datePickerValue(list) {
      if (list && list.length) {
        this.searchData.investigationTimeStart = dayjs(list[0]).format('YYYY-MM-DD HH:mm:ss')
        this.searchData.investigationTimeEnd = dayjs(list[1]).format('YYYY-MM-DD HH:mm:ss')
      } else {
        this.searchData.investigationTimeStart = ''
        this.searchData.investigationTimeEnd = ''
      }
    },
  },
  methods: {
    searchList() {
      this.pageNo = 1
      this.findList()
    },
    resetSearch() {
      this.searchData = this.$options.data()
      this.datePickerValue = []
      this.$refs.departmentSelect.userName = ''
      this.findList()
    },
    async findList() {
      this.loading = true
      const searchData = utils.deleteFormField(this.searchData)
      const data = {
        skipCount: (this.pageNo - 1) * this.pageSize,
        maxResultCount: this.pageSize,
        ...searchData,
      }
      const [err, res] = await hiddenDangerInvestigationPlanApi.pagedListQuery(data)
      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
        this.loading = false
      }
    },
    refreshList() {
      this.findList()
    },
    // 列表操作-事件
    handleEvent(row = null, operation) {
      switch (operation) {
        case 'delete':
          this.$confirm('请确认是否删除计划？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              const [err, res] = await hiddenDangerInvestigationPlanApi.callDelete(row.id)
              if (!err) {
                this.$message.success('删除成功')
                this.findList()
              }
            })
            .catch(() => {})
          break
        case 'create':
          this.initDialog(row, operation)
          break
        case 'read':
          this.initDialog(row, operation)
          break
        case 'update':
          this.initDialog(row, operation)
          break
        case 'completionStatus':
          this.initDialog(row, operation)
          break
        case 'publish':
          this.$confirm('请确认是否发布该计划？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              const [err, res] = await hiddenDangerInvestigationPlanApi.publishPlan({
                palanId: row.id,
              })
              if (!err) {
                this.$message.success('发布成功')
                this.findList()
              }
            })
            .catch(() => {})
          break
        default:
          break
      }
    },
    initDialog(row, operation) {
      // 没有新增获取数据
      this.id = row && row.id ? row.id : ''
      this.formProps.editType = operation
      this.formProps.title = `${
        // eslint-disable-next-line no-nested-ternary
        operation === 'create' ? '新增' : operation === 'update' ? '编辑' : '查看'
      }隐患排查计划`
      if (operation === 'create') {
        this.formData = this.$options.data().formData
      } else {
        this.formData = row
      }
      this.formDialog = true
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
</style>
